var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ExitToApp as LogoutIcon } from "@material-ui/icons";
import { Popover, MenuItem, IconButton, Avatar, Box, Typography, CircularProgress, Tooltip, Divider, ListItemIcon, } from "@material-ui/core";
import { memo, useCallback, useState } from "react";
import { useLayoutConsumers } from "../../provider";
import { useStyles } from "./styles";
var Profile = memo(function (props) {
    var menuId = "primary-search-account-menu";
    var classes = useStyles();
    var _a = useLayoutConsumers().profile.data, imageUrl = _a.imageUrl, firstName = _a.firstName, lastName = _a.lastName, currentPosition = _a.currentPosition;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var isMenuOpen = Boolean(anchorEl);
    var handleMenuClose = function () {
        setAnchorEl(null);
    };
    var handleProfileMenuOpen = useCallback(function (event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var renderMenu = (_jsxs(Popover, __assign({ anchorEl: anchorEl, id: menuId, anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "center",
        }, PaperProps: { className: classes.itemProfile }, open: isMenuOpen, onClose: handleMenuClose }, { children: [_jsx(MenuItem, { children: _jsxs(Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%" }, { children: [_jsx(Typography, __assign({ variant: "body1", className: classes.listItemText }, { children: "".concat(firstName, " ").concat(lastName) || "-" })), _jsx(Box, __assign({ display: "flex", flexDirection: "column" }, { children: _jsx(Typography, __assign({ variant: "body2", className: classes.role }, { children: currentPosition })) }))] })) }), _jsx(Divider, { className: classes.divider }), _jsxs(MenuItem, __assign({ onClick: function () {
                    setIsLoading(true);
                    props.onLogOut();
                } }, { children: [_jsx(ListItemIcon, __assign({ className: classes.iconLogOut }, { children: _jsx(LogoutIcon, { fontSize: "small" }) })), _jsx(Typography, __assign({ variant: "body1", className: classes.listItemText }, { children: "Logout" })), isLoading && (_jsx(Box, __assign({ pl: 2, display: "flex" }, { children: _jsx(CircularProgress, { size: 15 }) })))] }))] })));
    return (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ className: classes.sectionDesktop }, { children: _jsx(Tooltip, __assign({ title: "Account settings" }, { children: _jsx(IconButton, __assign({ onClick: function (e) { return handleProfileMenuOpen(e); }, size: "small", className: classes.avatar }, { children: _jsx(Avatar, { alt: "Iran AirTour", src: imageUrl ? imageUrl : "/static/images/avatar/1.jpg", className: classes.large }) })) })) })), renderMenu] }));
});
export { Profile };
